// @core/api/endpoints/userprofile/get_userprofile_default.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UserprofileResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Get default profile for user
 * Retrieves the default profile for a user, returning full profile data. Used to identify which profile to use in contexts where none is specified.
 */
export async function GetUserprofileDefault(
  user_id: string,
  options?: RequestOptions
): Promise<UserprofileResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/user/:user_id/default`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.get<UserprofileResponse>(requestPath, { ...requestOptions });
}
